import { v4 as uuidv4 } from "uuid";

export default class IdGenerator {
  public getId(): string {
    return uuidv4();
  }
}
